/* Do not change this file. */

import jwt_decode from "jwt-decode";
import { ROLE } from "@/helpers/const.js";

const auth = {
  state: {
    token: ""
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("SET_TOKEN", token);
    }
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getDecodedToken(_state, getters) {
      let token = getters.getToken;

      if (token) {
        token = jwt_decode(token);
      }

      return token;
    },
    getRole(_state, getters) {
      let token = getters.getDecodedToken;
      return token.role || "";
    },
    getFullname(_state, getters) {
      let token = getters.getDecodedToken;
      return token.fullname || "";
    },
    getONID(_state, getters) {
      let token = getters.getDecodedToken;
      return token.onid || "";
    },
    getExpirationTime(_state, getters) {
      let token = getters.getDecodedToken;
      return token.exp || 0;
    },
    getExpirationTimeRemaining(_state, getters) {
      if (!getters.getExpirationTime) {
        return 0;
      }
      let currentTime = Math.round(new Date().getTime() / 1000);

      return getters.getExpirationTime - currentTime;
    },

    /*
     * Does the user have a valid token?
     */
    isAuthenticated(_state, getters) {
      let token = getters.getDecodedToken;

      let isAuth = true;

      if (!token) {
        isAuth = false;
      }

      if (getters.getExpirationTimeRemaining < 0) {
        isAuth = false;
      }

      return isAuth;
    },
    isAdmin(_state, getters) {
      let token = getters.getDecodedToken;
      return getters.isAuthenticated && token.role === ROLE.ADMIN;
    }
  }
};

export default auth;
